// extracted by mini-css-extract-plugin
export default {"button":"HeaderCart_button__VxWhe","icon":"HeaderCart_icon__pxM99","badge":"HeaderCart_badge__pCR5M","bump":"HeaderCart_bump__nbEmn"};